if(!customElements.get('accordion-faq')) {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.accordion-section-faq__title');
    }

    toggle() {
      this.classList.toggle('open');
    }

    connectedCallback() {
      this.trigger.addEventListener('click', () => {
        this.toggle();
      });
    }
  }

  customElements.define('accordion-faq', AccordionItem);
}
